module.exports = __webpack_public_path__ + "img/card_ip_stipulation55.c3f4b593.svg";